/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ApiError } from './apiError';

export type GenericApiResponseListScheduledChangeSummaryError = ApiError | null;
